function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es6.array.index-of.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var UrlUtils = /*#__PURE__*/function () {
  function UrlUtils() {
    _classCallCheck(this, UrlUtils);
  }

  _createClass(UrlUtils, null, [{
    key: "AddQueryStringParams",
    value: function AddQueryStringParams(url, params) {
      var result = url || "";

      if (params != null) {
        // Remove fragment/hash if present
        var hashIndex = result.indexOf("#");

        if (hashIndex !== -1) {
          result = result.substring(0, hashIndex);
        }

        var questionMarkIdx = result.indexOf("?");

        if (questionMarkIdx === -1) {
          result += "?";
        } else if (questionMarkIdx < result.length - 1) {
          result += "&";
        }

        result += Object.entries(params).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value !== null && value !== void 0 ? value : ""));
        }).join("&");
      }

      return result;
    }
  }, {
    key: "GetQueryStringParamValue",
    value: function GetQueryStringParamValue(url, parameterName) {
      try {
        var currentUrl = url instanceof URL ? url : new URL(url);
        var keysArray = Array.from(currentUrl.searchParams.keys()); // Safari-safe conversion

        var matchedKey = keysArray.find(function (k) {
          return k.toLowerCase() === parameterName.toLowerCase();
        });

        if (!matchedKey) {
          return null;
        }

        return currentUrl.searchParams.get(matchedKey);
      } catch (err) {
        console.error("Invalid URL provided to GetQueryStringParamValue:", url);
        return null;
      }
    }
  }]);

  return UrlUtils;
}();